import React, { useRef } from 'react'

const ActionsRow = props => {
  const { filters, sorting } = props
  const inputFile = useRef()

  const loadFile = (file) => {
    if(file.size > 10000000) return window.alert('File size limit is 10MB')
    if (file.type != 'text/csv') return window.alert(' Only CSV files are allowed')

    props.onImportCredits(file)
  }

  const fileLoaded = (files) => {
    if (files && files[0]) loadFile(files[0])
  }

  return <div className='row'>
    <div className='col-lg-2'>
      <input
        className='form-control'
        placeholder='Search'
        value={props.searchValue}
        onChange={e => props.onChangeSearch(e.currentTarget.value)}
      />
    </div>
    <div className='col-lg-5'>
      <button className='btn btn-default filter-button' onClick={() => props.setShowFiltering(true)}>
        <img className='custom-icon' src='/images/players/filter.svg' />
        Filter {filters.length > 0 ? ` by ${filters.length}${filters.filter(el=>el.group).length > 0 ? '+' : ''}` : ''}
      </button>
      <button className='btn btn-default menu-button' onClick={() => props.setShowSorting(true)}>
        <img className='custom-icon' src='/images/players/sorting.svg' />
        Sort{sorting.length > 0 ? ` by ${sorting.length}` : ''}
      </button>
      { !props.showAll && filters.length > 0 && props.players.length == props.perPreview &&
        <button className='btn btn-default menu-button' onClick={props.onSetShowAll}>Show all</button>
      }
    </div>
    <div className='col-lg-5 text-right'>
      <input
        id='import-credits-file'
        type='file'
        accept='text/csv'
        ref={inputFile}
        onClick={e => e.target.value = null}
        onChange={e => fileLoaded(e.target.files)}
      />
      <button className='btn btn-default menu-button import-credits' title='Bulk import credits' onClick={() => inputFile.current.click()}>
        <img className='custom-icon' src='/images/players/import.svg' />
        <span title='Bulk import credits'> Import Credits</span>
      </button>
      <button className='clipboard-btn btn btn-default menu-button' type='button' onClick={() => props.copyPhonesToClipboard(' ')}>
        <img className='custom-icon' src='/images/players/duplicate.svg' />
        <span data-placement='top' data-toggle='tooltip'
              title='Copy all players phone number without commas'>  Copy Phones</span>
      </button>
      <button className='clipboard-btn btn btn-default menu-button' type='button' onClick={() => props.copyPhonesToClipboard(', ')}>
        <img className='custom-icon'  src='/images/players/comma.svg' />
        <span data-placement='top' data-toggle='tooltip'
              title='Copy all players phone number'>  Copy Phones</span>
      </button>
      <button className='btn btn-default menu-button' onClick={() => props.setShowViewsOn()}>
        <img className='custom-icon' src='/images/players/eye.svg' />
        Views { props.currentView ? '(' + props.currentView.title+')' : '' }
      </button>
    </div>
  </div>
}

export default ActionsRow
